import { isNil } from 'ramda';
import { useDragLayer } from 'react-dnd-cjs';

import { DraggableCard, DraggableDataCard } from 'components';
import { dragItems } from 'constants/general';

const innerStyle = {
	display: 'inline-block',
	transform: 'rotate(-7deg)',
	WebkitTransform: 'rotate(-7deg)',
	WebkitBackfaceVisibility: 'hidden', // anti aliasing magic!
	boxShadow: '5px 5px 15px 0px rgba(0, 0, 0, 0.05), -5px -5px 15px 0px rgba(0, 0, 0, 0.05)',
};

const layerStyles = {
	position: 'fixed',
	pointerEvents: 'none',
	zIndex: 1000000,
	left: 0,
	top: 0,
	width: '100%',
	height: '100%',
};

// Styles for draggable wrapper that follows mouse
const getItemStyles = (initialOffset, currentOffset) => {
	if (!initialOffset || !currentOffset) {
		return {
			display: 'none',
		};
	}

	const { x, y } = currentOffset;

	const transform = `translate(${x}px, ${y}px)`;

	return {
		transform,
		WebkitTransform: transform,
	};
};

const renderItem = (itemType, item) => {
	switch (itemType) {
		case dragItems.CAMPAIGN_STATE:
		case dragItems.CAMPAIGN_DATA_COLUMN:
			return <DraggableCard text={item.payload.shortDescription} />;
		case dragItems.ADDITIONAL_DATA:
			if (isNil(item.index)) {
				return <DraggableCard text={item.payload.key} />;
			} else {
				return (
					<div style={{ width: item.componentWidth }}>
						<DraggableDataCard index={item.index} data={item.payload} />
					</div>
				);
			}
		default:
			return null;
	}
};

// HTML 5 dnd API has no support for custom drag item. This creates layer on which dragged item is rendered
const CustomDragLayer = () => {
	const { item, itemType, isDragging, initialOffset, currentOffset } = useDragLayer((monitor) => ({
		item: monitor.getItem(),
		itemType: monitor.getItemType(),
		initialOffset: monitor.getInitialSourceClientOffset(),
		currentOffset: monitor.getSourceClientOffset(),
		isDragging: monitor.isDragging(),
	}));

	if (!isDragging) {
		return null;
	}

	return (
		<div style={layerStyles}>
			<div style={getItemStyles(initialOffset, currentOffset)}>
				<div style={innerStyle}>{renderItem(itemType, item)}</div>
			</div>
		</div>
	);
};

export default CustomDragLayer;
